import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@opoint/infomedia-storybook'

type Props = {
  isShown: boolean
  onHide: () => void
  onConfirm: () => void
}

const DeleteConfirmationModal = ({ isShown, onHide, onConfirm }: Props) => {
  return (
    <AlertDialog
      open={isShown}
      onOpenChange={() => {
        onHide()
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Are you sure you wish to delete this query?
          </AlertDialogTitle>
          <AlertDialogDescription>
            The deleted query cannot be restored
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button type="button" variant="outline">
              Cancel
            </Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              onClick={() => {
                onConfirm()
              }}
              type="button"
            >
              Delete
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteConfirmationModal
